import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TGetUserRolesGroupedResponsePayload,
	TGetUserRolesByUserIdResponsePayload,
	TGetUserRolesResponsePayload,
	TGetRolesResponsePayload,
	TUserRolesStore,
	TGetRolesResponse,
} from './types';

const getUserRolesState = (state: TStoreState): TUserRolesStore => state.userRoles;
export const getUserRoles = createSelector([getUserRolesState], (s: TUserRolesStore) => s);

export const getRoles = createSelector(
	[getUserRoles],
	(s: TUserRolesStore): TGetRolesResponsePayload => s.roles,
);
export const getRolesLoading = createSelector(
	[getUserRoles],
	(s: TUserRolesStore): boolean => s.rolesLoading,
);

export const getUserRolesGrouped = createSelector(
	[getUserRoles],
	(s: TUserRolesStore): TGetUserRolesGroupedResponsePayload => s.grouped,
);
export const getUserRolesGroupedLoading = createSelector(
	[getUserRoles],
	(s: TUserRolesStore): boolean => s.groupedLoading,
);

export const getUserRolesList = createSelector(
	[getUserRoles],
	(s: TUserRolesStore): TGetUserRolesResponsePayload => s.userRoles,
);
export const getUserRolesListLoading = createSelector(
	[getUserRoles],
	(s: TUserRolesStore): boolean => s.userRolesLoading,
);

export const getUserRolesByUserId = createSelector(
	[getUserRoles],
	(s: TUserRolesStore): TGetUserRolesByUserIdResponsePayload => s.userRolesByUserId,
);
export const getUserRolesByUserIdLoading = createSelector(
	[getUserRoles],
	(s: TUserRolesStore): boolean => s.userRolesByUserIdLoading,
);

export const getAssignUserRolesLoading = createSelector(
	[getUserRoles],
	(s: TUserRolesStore): boolean => s.assignLoading,
);
export const getUpdateUserRoleLoading = createSelector(
	[getUserRoles],
	(s: TUserRolesStore): boolean => s.updateLoading,
);
export const getRemoveUserRoleLoading = createSelector(
	[getUserRoles],
	(s: TUserRolesStore): boolean => s.removeLoading,
);
